// import liskovLogo from "../images/logos/Liskov_logo.svg";
import { ReactComponent as MichaelLogo } from "../images/logos/Liskov_logo.svg";

function LandingPage() {
	const handleClick = (id) => {
		console.log(`HIT THE LINK ${id}`);
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<div className="landing-page">
			<div className="landing-page-header">
				<div className="landing-page-title">
					<h2>
						{" "}
						{">"} Liskov is coming to Melbourne
						<span id="blinking-cursor">_</span>{" "}
					</h2>
				</div>
				<div className="landing-sub-heading">
					<span>
						🛫 Liskov is a coding and design school with courses starting in
						Melbourne in 2023.
					</span>
				</div>
				<div className="landing-sub-heading">
					<span>🛬 An alternative path into tech in 6 months. </span>
				</div>
			</div>
			<div className="landing-page-points">
				<div>
					<h3>🌏 Small class size and full support.</h3>
				</div>
				<div>
					<h3>👾 Learn to code from people in the industry.</h3>
				</div>
				<div>
					<h3>👨🏼‍🏫 Teacher owned and run.</h3>
				</div>
			</div>
            <div className="call-to-action-and-logo">
                <div
                    className="landing-call-to-action"
                    onClick={() => handleClick("contact-section")}
                >
                    <span className='telephone-emoji'>☎️</span>  Get in touch...
                </div>
                {/* <img id="liskov-logo-landing" src={liskovLogo} alt="liskov logo" /> */}
                {/* <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
                    <use xlinkHref={liskovLogo} />
                </svg> */}
                {/* <div className="logo-container">
                    <MichaelLogo id="liskov-logo-landing" />
                </div> */}
            </div>
		</div>
	);
}

export default LandingPage;
